module.exports = __webpack_public_path__ + "img/logo_automagz.1841fbfa.png";